// Central data-testid catalogue — kebab-case, function-driven names.
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkModules: "nav-link-modules",
  linkPricing: "nav-link-pricing",
  linkDocs: "nav-link-docs",
  linkSupport: "nav-link-support",
  linkContact: "nav-link-contact",
  loginBtn: "nav-login-btn",
  registerBtn: "nav-register-btn",
  dashboardBtn: "nav-dashboard-btn",
  logoutBtn: "nav-logout-btn",
  userMenu: "nav-user-menu",
};

export const AUTH = {
  registerTitle: "register-title",
  registerFirstName: "register-first-name",
  registerLastName: "register-last-name",
  registerUsername: "register-username",
  registerEmail: "register-email",
  registerMobile: "register-mobile",
  registerOrganization: "register-organization",
  registerAffiliation: "register-affiliation",
  registerCity: "register-city",
  registerState: "register-state",
  registerCountry: "register-country",
  registerReferral: "register-referral",
  registerPassword: "register-password",
  registerSubmit: "register-submit",
  otpInput: "otp-input",
  otpSubmit: "otp-submit",
  otpResend: "otp-resend",
  loginIdentifier: "login-identifier",
  loginPassword: "login-password",
  loginSubmit: "login-submit",
  forgotPasswordLink: "forgot-password-link",
  forgotUsernameLink: "forgot-username-link",
  forgotEmail: "forgot-email",
  forgotSubmit: "forgot-submit",
  resetPassword: "reset-password",
  resetSubmit: "reset-submit",
};

export const USER = {
  dashboard: "user-dashboard",
  kpiTotalJobs: "kpi-total-jobs",
  kpiAvailableCredits: "kpi-available-credits",
  kpiFrozenCredits: "kpi-frozen-credits",
  kpiCompletedJobs: "kpi-completed-jobs",
  newJobBtn: "new-job-btn",
  buyCreditsBtn: "buy-credits-btn",
  jobsTable: "jobs-table",
  jobRow: (id) => `job-row-${id}`,
  wizardModuleSelect: "wizard-module-select",
  wizardProjectName: "wizard-project-name",
  wizardShortNotes: "wizard-short-notes",
  wizardNumSamples: "wizard-num-samples",
  wizardSampleUrl: (i) => `wizard-sample-url-${i}`,
  wizardNext: "wizard-next",
  wizardPrev: "wizard-prev",
  wizardSubmit: "wizard-submit",
  buyPlan: (id) => `buy-plan-${id}`,
  buyCustomInput: "buy-custom-input",
  buyCustomSubmit: "buy-custom-submit",
};

export const ADMIN = {
  dashboard: "admin-dashboard",
  usersTable: "admin-users-table",
  jobsTable: "admin-jobs-table",
  cmsPageList: "admin-cms-page-list",
  cmsPageJson: "admin-cms-page-json",
  cmsSaveBtn: "admin-cms-save-btn",
  jobStatusSelect: "admin-job-status-select",
  jobStatusSubmit: "admin-job-status-submit",
};
